import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';
import Constants from '@usas/ui-web/utils/Constants';

const GetMeetOfficialRoleTypeData = (orgLevelId, officialPositionTypeId, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...',
      orgLevelId: orgLevelId,
      officialPositionTypeId: officialPositionTypeId
    };
    setState(newState);

    const orgLevelIdForUrl = orgLevelId ? encodeURIComponent(orgLevelId) : '';
    const officialPositionTypeIdForUrl = officialPositionTypeId ? encodeURIComponent(officialPositionTypeId) : '';
    const url = `/MeetOfficialRoleType?orgLevelId=${orgLevelIdForUrl}&officialPositionTypeId=${officialPositionTypeIdForUrl}`;
    PersonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          const data = JSON.parse(JSON.stringify(arrayData));
          const blankRole = { meetOfficialRoleTypeId: Constants.DEFAULT_ID };
          data.unshift(blankRole);
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            options: data.map((role) => { return { id: role.meetOfficialRoleTypeId, name: role.meetOfficialRoleTypeId !== Constants.DEFAULT_ID ? `${role.roleTypeName || ''} (${role.roleTypeAbbreviation || ''})` : '--' } }),
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetMeetOfficialRoleTypeData;